import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/aa53e321-a1cd-4f43-9500-467d5676d8c9";
export const REGISTER_URL = "https://a.ntrk2.com/28c62bbe-dcae-4309-aa6a-9181a1d24fa5";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://getph.kzw2a.com/download?openExternalBrowser=1&id=k1cg1ghpl30ft6w";

export * from "./codes";
export * from "./context";
